import { render, staticRenderFns } from "./RevizorClientAreaStatisticsPage.vue?vue&type=template&id=922b4682&scoped=true&"
import script from "./RevizorClientAreaStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./RevizorClientAreaStatisticsPage.vue?vue&type=script&lang=js&"
import style0 from "./RevizorClientAreaStatisticsPage.vue?vue&type=style&index=0&id=922b4682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922b4682",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardText,VCol,VIcon,VResponsive,VRow,VSheet,VSimpleTable,VToolbar})
